// extracted by mini-css-extract-plugin
export var home = "bgqc-module--home--3zgTa";
export var header = "bgqc-module--header--h2Bt5";
export var pstyles = "bgqc-module--pstyles--1nQqE";